import { Region } from "../shared/interfaces/Region";
import { UserRoles } from "./UserRolesEnum";

export function isCompanySiteEmpty(companySite: Region): boolean {
  if (companySite == null) {
    return true;
  }

  for (let prop in companySite) {
    const value = companySite[prop as keyof typeof companySite];
    if (value !== undefined) {
      return false;
    }
  }

  return true;
}

export function userRoleStringRemoveSpaceAndCaptialiseFirstLetter(userRole: string) {
  userRole = userRole.replace(" ", "");
  userRole = userRole.charAt(0).toUpperCase() + userRole.slice(1);
  return userRole;
}

export function getUserRoleFromStringValue(userRole: UserRoles | undefined) {
  if (userRole != null) {
    let userRoleString = userRole.toString();
    userRoleString = userRoleString.replace(" ", "");
    userRoleString = userRoleString.charAt(0).toLowerCase() + userRole.slice(1);

    switch (userRoleString) {
      case "fieldUser":
        return UserRoles.FieldUser;
      case "standardUser":
        return UserRoles.StandardUser;
      case "expertUser":
        return UserRoles.ExpertUser;
      case "adminUser":
        return UserRoles.AdminUser;
      case "superAdmin":
        return UserRoles.SuperAdmin;
    }
  }
  return userRole;
}
